import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  Input,
  IconButton,
  Flex,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { CopyIcon } from "@chakra-ui/icons";

const ShareLinkModal = ({ isOpen, onClose, agenda, onCopy }) => {
  const toast = useToast();

  const handleCopyJoinUrl = () => {
    if (agenda?.joinCode) {
      const joinUrl = `${window.location.origin}/join/${agenda.joinCode}`;
      navigator.clipboard.writeText(joinUrl);
      toast({
        title: "Join URL copied to clipboard",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
      if (onCopy) onCopy();
    }
  };

  const handleCopyJoinCode = () => {
    if (agenda?.joinCode) {
      navigator.clipboard.writeText(agenda.joinCode);
      toast({
        title: "Join code copied to clipboard",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
      if (onCopy) onCopy();
    }
  };

  if (!agenda?.joinCode) {
    return null;
  }

  const joinUrl = `${window.location.origin}/join/${agenda.joinCode}`;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Share Meeting Link</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={4} align="stretch">
            {/* Full Join URL */}
            <Box>
              <Text fontSize="sm" color="gray.600" mb={2} fontWeight="500">
                Full Join Link:
              </Text>
              <Flex alignItems="center" gap={2}>
                <Input
                  value={joinUrl}
                  isReadOnly
                  size="md"
                  fontSize="sm"
                  bg="gray.50"
                  border="1px solid #E2E8F0"
                  data-testid="share-modal-join-url-input"
                  flex={1}
                />
                <IconButton
                  icon={<CopyIcon />}
                  onClick={handleCopyJoinUrl}
                  aria-label="Copy join URL"
                  variant="outline"
                  size="md"
                  data-testid="share-modal-copy-join-url-button"
                />
              </Flex>
            </Box>

            {/* Join Code Only */}
            <Box>
              <Text fontSize="sm" color="gray.600" mb={2} fontWeight="500">
                Join Code Only:
              </Text>
              <Flex alignItems="center" gap={2}>
                <Input
                  value={agenda.joinCode}
                  isReadOnly
                  size="md"
                  fontSize="sm"
                  bg="gray.50"
                  border="1px solid #E2E8F0"
                  data-testid="share-modal-join-code-input"
                  flex={1}
                />
                <IconButton
                  icon={<CopyIcon />}
                  onClick={handleCopyJoinCode}
                  aria-label="Copy join code"
                  variant="outline"
                  size="md"
                />
              </Flex>
            </Box>

            <Text fontSize="xs" color="gray.500" mt={2}>
              Participants can use either the full link or enter the join code
              on your meeting page.
            </Text>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ShareLinkModal;
